import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useGetHelpQuery } from 'services/cms';
import { chunkArrayIntoN } from 'utils/array';

import CollapseGroup from 'components/Collapse/CollapseGroup';
import HelpPageLayout from 'components/Help/HelpPageLayout';
import IsLoading from 'components/isLoading';

const FAQSectionScreen: React.FC = () => {
  const { data, isLoading } = useGetHelpQuery();
  const contentGap = useBreakpointValueGS({ xl: 0, lg: 0, base: 8 }) || 8;
  const viewDirection = useBreakpointValueGS({ xl: 'row', lg: 'row', base: 'column' });

  const items = useMemo(() => {
    if (!data?.faq?.faqItems) return [];
    return data.faq.faqItems.map((item) => ({ title: item.title, content: item.description }));
  }, [data]);

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <IsLoading />
      </View>
    );
  }

  if (!data) {
    // TODO: definir comportamento ao receber erros da API
    return null;
  }

  return (
    <HelpPageLayout title={data.faq.title}>
      <View style={[styles.faqContainer, { flexDirection: viewDirection, gap: contentGap }]}>
        {chunkArrayIntoN(items, 1).map((chunk) => (
          <CollapseGroup items={chunk} />
        ))}
      </View>
    </HelpPageLayout>
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  faqContainer: {
    // flexDirection e gap serão controlados dinamicamente
  },
});

export default FAQSectionScreen;
